






























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import SaveButton from '@/components/App/SaveButton.vue';
import axios, { AxiosResponse } from 'axios';
import env from '@/env.ts';
import SelectEnvironmentDialog from '@/components/Dialogues/SelectEnvironmentDialog.vue';
import CyclesDialog from '@/components/Dialogues/CyclesDialog.vue';
import { Attribute, Module, Responsible, Role, Environment } from '@/types';
import DeleteCutoverplanDialog from '@/components/Dialogues/DeleteCutoverplanDialog.vue';
import { Issue } from '@/interfaces/Issue';
import { Changelog } from '@/interfaces/Changelog';
import { Cutoverplan } from '@/interfaces/Cutoverplan';
import { Step } from '@/interfaces/Step';
import AppSAPBadge from '@/components/App/AppSAPBadge.vue';

@Component({
  components: {
    AppSAPBadge,
    DeleteCutoverplanDialog,
    CyclesDialog,
    SelectEnvironmentDialog,
    SaveButton
  }
})
export default class EditCutoverplanView extends Vue {
  @Watch('cutoverplan.modules')
  async watchModules() {
    await this.refreshModules();
  }

  selectedEnvironment = 0;

  get modules() {
    return this.$store.state.modules;
  }

  set modules(value) {
    this.$store.commit('setModules', value);
  }

  get allResponsiblesForSelect() {
    return this.$store.state.all_responsibles.map((r: Responsible) => ({
      text: r.name,
      value: r.id
    }));
  }

  get selectedEnvironmentName() {
    return this.selectedEnvironment
      ? this.$store.state.all_environments.find(
          (environment: Environment) => environment.id === this.selectedEnvironment
        ).name
      : 'DEFAULT';
  }

  cutoverplan: Cutoverplan = ({
    responsibles: [],
    includes: [],
    environments: []
  } as unknown) as Cutoverplan;

  id = 0;

  autoSaveInterval: any = null;

  cycleLoading = false;

  attributes = [];

  async created() {
    const urlParams = window.location.search?.split('=');
    if (urlParams.length > 1) this.selectedEnvironment = +urlParams[1];

    await this.load();
  }

  async refreshModules() {
    if (this.cutoverplan?.modules) {
      this.modules = [];
      for (const module_id of this.cutoverplan.modules) {
        await this.loadModule((module_id as unknown) as number);
      }
      this.modules?.sort((a: Module, b: Module) => a.position - b.position);
    }
  }

  async load() {
    this.$emit('showPreloader');
    const loading_promises: Promise<any>[] = [];
    this.id = +this.$route.params.cutoverplan_id;

    const { data: attributes } = await axios.get(
      `${env.backend_url}/all_attributes?cutoverplanId=${this.id}`
    );
    this.attributes = attributes.filter(
      (attribute: Attribute) => attribute.cutoverplan_id === this.id
    );

    this.modules = [];
    const { data: cutoverplan } = await axios.get(`${env.backend_url}/cutoverplan/${this.id}`);
    this.cutoverplan = cutoverplan;

    const moduleRolesNotSet = cutoverplan.module_roles
      .filter(
        (role: Role) =>
          role.id &&
          !cutoverplan.responsibles.some(
            (responsible: Responsible) => responsible.role_id === role.id
          )
      )
      .map((role: Role) => ({ responsible_id: null, role_id: role.id, cutoverplan_id: this.id }));
    this.cutoverplan.responsibles = [...cutoverplan.responsibles, ...moduleRolesNotSet].sort(
      (a, b) => a.position - b.position
    );

    Promise.all([...loading_promises]).then(() => {
      this.$emit('loadingFinished');
    });
  }

  async loadModule(module_id: number) {
    const modulePromise = axios.get(`${env.backend_url}/module/${module_id}`);
    const stepsPromise = axios.get(`${env.backend_url}/module/all_steps/${module_id}`);

    const module = (await modulePromise).data;
    module.steps = (await stepsPromise).data;
    this.modules.push(module);
  }

  async saveCutoverplan() {
    const updatePromises: Promise<AxiosResponse>[] = [];

    this.attributes.forEach((attribute) => {
      updatePromises.push(axios.post(`${env.backend_url}/attribute/update`, attribute));
    });

    this.cutoverplan.issues.forEach((issue: Issue, index: number) => {
      issue.position = index;
      updatePromises.push(axios.put(`${env.backend_url}/issue`, issue));
    });

    this.cutoverplan.changelogs.forEach((changelog: Changelog, index: number) => {
      changelog.position = index;
      updatePromises.push(axios.put(`${env.backend_url}/changelog`, changelog));
    });

    await Promise.all(updatePromises);
    this.cutoverplan.modules = this.modules.map((module: Module) => module.id);
    const { data } = await axios.post(
      `${env.backend_url}/cutoverplan/update/${this.cutoverplan.id}`,
      this.cutoverplan
    );
    if (data.state) this.cutoverplan.state = data.state;
    return { status: 200 };
  }

  cycles = [];

  showCyclesDialog = false;

  async findCycles() {
    this.cycleLoading = true;
    const { data: cycles } = await axios.get(`${env.backend_url}/cycles/${this.cutoverplan.id}`);
    this.cycles = cycles;
    this.showCyclesDialog = true;
    this.cycleLoading = false;
  }
}
